const apiBaseUrl = "https://www.myspeedymarket.fi/shopify";

/******************************************** 全局变量 *************************************/

/******************************************** 工具函数 *************************************/


// 获取公钥信息
async function getPublicKeyInfo() {
    const data = await getPublicKey();
    const publicKey = await importPublicKeyFromBase64String(data.publicKey);

    let publicKeyInfo = {
        publicKey: publicKey,
        code: data.code
    };
    return publicKeyInfo;
}

// 密钥生成参数
const keyGenParams = {
    name: "RSA-OAEP",
    modulusLength: 2048,    // 可以是1024, 2048, 或4096
    publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
    hash: { name: "SHA-256" },
};

// 密钥导入参数
const keyImportParams = {
    name: "RSA-OAEP",
    hash: { name: "SHA-256" }
};

// 加密参数
const encryptParams = {
    name: "RSA-OAEP",
    hash: { name: "SHA-256" }
};

// 生成密钥对
async function generateKeyPair() {
    return await window.crypto.subtle.generateKey(
        keyGenParams,
        true, // 密钥是否可导出
        ["encrypt", "decrypt"] // 密钥用途
    );
}

// 从Base64字符串导入公钥
async function importPublicKeyFromBase64String(publicKeyBase64String) {
    // Base64解码
    const publicKeyByteArray = Uint8Array.from(atob(publicKeyBase64String), c => c.charCodeAt(0));

    return await window.crypto.subtle.importKey(
        "spki",
        publicKeyByteArray,
        keyImportParams,
        true,
        ["encrypt"]
    );
}

// 加密数据
async function encryptData(publicKey, data) {
    const encodedData = new TextEncoder().encode(data);
    let encryptBytes = await window.crypto.subtle.encrypt(
        encryptParams,
        publicKey,
        encodedData
    );

    let binary = '';
    let tempBytes = new Uint8Array(encryptBytes);
    const len = tempBytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(tempBytes[i]);
    }
    return window.btoa(binary);
}

function getCurrentTimestamp() {
    // 创建表示当前时间的 Date 对象
    const now = new Date();

    // 获取时间各部分
    const year = now.getFullYear();             // 2025 (年份)
    const month = now.getMonth() + 1;           // 1-12 (月份，0-11所以要+1)
    const day = now.getDate();                  // 1-31 (日期)
    const hour = now.getHours();                // 0-23 (小时)
    const minute = now.getMinutes();            // 0-59 (分钟)
    const second = now.getSeconds();            // 0-59 (秒)
    const millisecond = now.getMilliseconds();  // 0-999 (毫秒)

    return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')} ` +
        `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}.${String(millisecond).padStart(3, '0')}`;
}

// 生成GUID
function generateGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

// 生成订单号：SP + 9位数字（基于UUID保证唯一性）
function generateOrderNo() {
    // 生成UUID
    const uuid = generateGUID();
    
    // 将UUID转换为数字哈希值
    let hash = 0;
    for (let i = 0; i < uuid.length; i++) {
        const char = uuid.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // 转换为32位整数
    }
    
    // 取绝对值并转换为9位数字字符串
    const numericString = Math.abs(hash).toString().padStart(9, '0');
    
    // 如果超过9位，取后9位
    const nineDigits = numericString.slice(-9);
    
    return 'SP' + nineDigits;
}

// 使用Promise包装FileReader
function readFileAsArrayBuffer(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(new Error('文件读取失败'));

        reader.readAsArrayBuffer(file);
    });
}

// 使用Promise包装FileReader
function readFileAsArrayBufferBase64String(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            let tempString = '';
            let tempBytes = new Uint8Array(e.target.result);
            const len = tempBytes.byteLength;
            for (let i = 0; i < len; i++) {
                tempString += String.fromCharCode(tempBytes[i]);
            }
            resolve(window.btoa(tempString));
        };
        reader.onerror = (e) => reject(new Error('文件读取失败'));

        reader.readAsArrayBuffer(file);
    });
}


/******************************************** 后台OPEN_API *************************************/

async function getPublicKey() {
    const url = `${apiBaseUrl}/api/v1/front/auth/getPublicKey`
    const headers = {
        'Accept': '*/*',
    };

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: headers
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        if (result.code === 0) {
            return result.data; // { publicKey, code }
        } else {
            throw new Error(`API error! msg: ${result.msg}`);
        }
    } catch (error) {
        console.error('Error fetching public key:', error);
        throw error;
    }
}

// 生成认证头部
async function generateAuthenticationHeaders() {
    // 获取客户ID
    const customerId = await getCustomerId();
    // 当前时间戳
    const timestamp = getCurrentTimestamp();
    // 获取公钥，生成token
    const publicKeyInfo = await getPublicKeyInfo();
    const token = await encryptData(publicKeyInfo.publicKey, `${customerId}${timestamp}`);

    return {
        't-env': token,
        't-time': timestamp,
        't-code': publicKeyInfo.code
    };
}

// 订单
async function splitOrder(params) {
    const headers = await generateAuthenticationHeaders();
    headers['Content-Type'] = 'application/json';

    return fetch(`${apiBaseUrl}/api/v1/front/goods/split`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(params)
    })
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

// 更新子单地址
async function updateSplitOrderAddress(orderId, batchNo, recipientAddress = null) {
    // 获取客户ID
    const customerId = await getCustomerId();
    // 当前时间戳
    const timestamp = getCurrentTimestamp();
    // 获取公钥，生成token
    const publicKeyInfo = await getPublicKeyInfo();
    const token = await encryptData(publicKeyInfo.publicKey, `${customerId}${timestamp}`);

    // 构建请求体
    const requestBody = {
        orderId: orderId,
        batchNoCurrent: batchNo
    };

    // 如果提供了收件人地址，添加到请求体中
    if (recipientAddress) {
        requestBody.recipientAddress = recipientAddress;
    }

    return fetch(`${apiBaseUrl}/api/v1/front/goods/updateAddress`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            't-env': token,
            't-time': timestamp,
            't-code': publicKeyInfo.code
        },
        body: JSON.stringify(requestBody)
    })
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

async function confirmSplitOrder(orders) {
    // 获取客户ID
    const customerId = await getCustomerId();
    // 当前时间戳
    const timestamp = getCurrentTimestamp();
    // 获取公钥，生成token
    const publicKeyInfo = await getPublicKeyInfo();
    const token = await encryptData(publicKeyInfo.publicKey, `${customerId}${timestamp}`);

    return fetch(`${apiBaseUrl}/api/v1/front/goods/confirm`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            't-env': token,
            't-time': timestamp,
            't-code': publicKeyInfo.code
        },
        body: JSON.stringify({ orders: orders })
    })
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
        });
}

// 获取中国省份
async function getChinaProvinces() {
    return fetch(`${apiBaseUrl}/api/v1/front/region/provinces`)
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

// 按省份获取城市
async function getChinaCitiesByProvince(provinceCode) {
    return fetch(`${apiBaseUrl}/api/v1/front/region/cities?provinceCode=${provinceCode}`)
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

// 按城市获取区
async function getChinaAreasByCity(cityCode) {
    return fetch(`${apiBaseUrl}/api/v1/front/region/districts?cityCode=${cityCode}`)
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

// 查询所有的发件人地址
async function getAllSenderAddresses() {
    const headers = await generateAuthenticationHeaders();

    return fetch(`${apiBaseUrl}/api/v1/front/address/sender/getUserById`, {
        headers: headers
    })
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

// 删除指定的发件人地址
async function deleteSenderAddress(id) {
    const headers = await generateAuthenticationHeaders();

    return fetch(`${apiBaseUrl}/api/v1/front/address/sender/delete?id=${id}`, {
        method: 'DELETE',
        headers: headers
    })
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

// 添加获取更新发件人地址
async function addOrUpdateSenderAddress(addressInfo) {
    const headers = await generateAuthenticationHeaders();
    headers['Content-Type'] = 'application/json';

    return fetch(`${apiBaseUrl}/api/v1/front/address/sender/createOrUpdate`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(addressInfo)
    })
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
        });
}

// 查询所有的收件人地址
async function getAllReceiverAddresses() {
    const headers = await generateAuthenticationHeaders();

    return fetch(`${apiBaseUrl}/api/v1/front/address/recipient/getByUserId`, {
        headers: headers
    })
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

// 删除指定的收件人地址
async function deleteReceiverAddress(id) {
    const headers = await generateAuthenticationHeaders();

    return fetch(`${apiBaseUrl}/api/v1/front/address/recipient/delete?id=${id}`, {
        method: 'DELETE',
        headers: headers
    })
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
            return response.data;
        });
}

// 添加获取更新收件人地址
async function addOrUpdateReceiverAddress(addressInfo) {
    const headers = await generateAuthenticationHeaders();
    headers['Content-Type'] = 'application/json';

    return fetch(`${apiBaseUrl}/api/v1/front/address/recipient/createOrUpdate`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(addressInfo)
    })
        .then(response => response.json())
        .then(response => {
            if (response.code != 0) {
                throw new Error(response.msg);
            }
        });
}

// 同步购物车信息
async function syncCartInfo(cartId, key) {
  try {
    const headers = await generateAuthenticationHeaders();
    headers['Content-Type'] = 'application/json';

    console.log('cart headers info:', headers);

    const response = await fetch(
      `${apiBaseUrl}/api/v1/webhook/shopify/cart/info`,
      {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ cartId, key }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseData = await response.json();
    if (responseData.code != 0) {
      throw new Error(responseData.msg);
    }

    return responseData.data;
  } catch (error) {
    console.error('Error syncing cart info:', error);
    throw error;
  }
}

/******************************************** 和shopify后台服务交互 *************************************/

// 获取当前登录的用户ID
async function getCustomerId() {
    // TODO 本地开发环境，返回模拟客户ID
    if (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost') {
        console.log('本地开发环境，返回模拟客户ID: wanhouchao');
        return 'wanhouchao';
    }

    // try {
    //     const response = await fetch('/account.json');
        
    //     // If the response is not OK (e.g., 404 Not Found), it means the customer is not logged in.
    //     if (!response.ok) {
    //         throw new Error("当前未登录");
    //     }

    //     const data = await response.json();

    //     if (data.customer) {
    //         console.log('客户ID:', data.customer.id);
    //         return data.customer.id;
    //     } else {
    //         throw new Error("当前未登录");
    //     }
    // } catch (error) {
    //     console.error('获取客户ID时出错:', error.message);
    //     // Throw a new error to ensure the calling function knows about the failure.
    //     // We can check if the message is one we already set to avoid nesting "Error: Error: ..."
    //     if (error.message === "当前未登录") {
    //         throw error;
    //     }
    //     throw new Error("获取客户ID失败");
    // }

    if (window.customerData && window.customerData.loggedIn) {
        return window.customerData.id;
    // 使用客户 ID
    } else {
        throw new Error("当前未登录");
    }
};

// 获取购物车信息
async function getCartInfo() {
    return await fetch('/cart.js')
        .then(response => response.json())
        .catch(err => {
            console.log('获取购物车信息失败：', err);
            throw new Error("从shopify获取购物车信息失败");
        });
}

// 更新购物车属性
async function updateCartAttributes(attributes) {
    const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ attributes })
    })
        .catch(err => {
            throw new Error('更新购物车属性失败');
        });

    if (!response.ok) {
        throw new Error('更新购物车属性失败');
    }

    return response.json();
}